"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacesContract = exports.linkedStorySchema = exports.spaceTeaserSchema = exports.spaceSchema = exports.PREVIEW_EMBED_MAX_LIMIT = exports.spacePreviewSchema = exports.commentTeaserPreviewSchema = exports.spaceNameSchema = exports.SPACE_NAME_MAX_LENGTH = exports.SPACE_NAME_MIN_LENGTH = exports.spaceFormatSchema = exports.SPACE_FORMATS = exports.SPACE_STATUSES = void 0;
exports.errorInvalidName = errorInvalidName;
exports.errorDuplicateSpace = errorDuplicateSpace;
exports.errorFormatNotEnabled = errorFormatNotEnabled;
exports.errorModerationModeNotEnabled = errorModerationModeNotEnabled;
/**
 * Spaces: contract definitions and typed-error factories, one block per
 * procedure.
 *
 * Each procedure is a named local const built off `baseProcedure`. Its
 * `.route(...)` block defines the REST mapping (e.g. `spaces.create` is exposed
 * as `POST /silo/{siloKey}/spaces` on the OpenAPI transport, and via typed
 * JSON-RPC for the client). Throw-helpers for that procedure's typed errors
 * live next to it; the server core function imports and throws them
 * (`server/modules/questions.ts`, currently — the legacy module retains the
 * `question` name internally even though the API surface is `spaces`).
 * `spacesContract` at the bottom is the per-resource index that `contract.ts`
 * composes into the full `AppContract`.
 *
 * Keys in the route template (`{siloKey}`, `{spaceKey}`) are path parameters,
 * not body fields. On the REST transport, duplicating one in the JSON body with
 * a different value lets the body silently win — see the path/body precedence
 * note in `docs/architecture/orpc.md`.
 *
 * English error messages are load-bearing: clients on the legacy transport read
 * `error` as a string and display it to the user.
 *
 * Most procedures act on the space's own row, but three model comment-backed
 * space state: `teaser` (the self-contained teaser-embed payload — the v2
 * successor to the legacy `/questions/getMetadata`) and the `featureComment` /
 * `unfeatureComment` mutations that set or clear the space's featured comment.
 * These read/write the instance's comment collection and teaser-feature
 * instance property rather than the question row, so their server handlers
 * delegate to `server/modules/comments/*` instead of `questions.ts`.
 * `linkedStories` is a fourth exception: it reads the space's links to story
 * instances, so its handler delegates to `server/modules/article.ts`.
 */
const client_1 = require("@orpc/client");
const z = __importStar(require("zod"));
const locale_1 = require("../../locale");
const moderation_modes_1 = require("../../moderation-modes");
const reaction_sets_1 = require("../../reaction-sets");
const roles_capabilities_1 = require("../../roles-capabilities");
const api_schemas_1 = require("../api-schemas");
const base_1 = require("../base");
const multi_language_1 = require("../multi-language");
const schemas_1 = require("../schemas");
const types_1 = require("../types");
const comments_1 = require("./comments");
const spaceStatusSchema = z.enum(['draft', 'active', 'closed']);
exports.SPACE_STATUSES = spaceStatusSchema.options;
/**
 * The conversation formats a space can be created with — one per editorial-dash
 * template key (`client/feature/editorial-dash/templates/`). Kept here on the
 * contract because `create`/`update` validate against it; the client templates
 * are the runtime source and must stay in lockstep with this list.
 */
exports.SPACE_FORMATS = ['audience-input', 'comment-slider', 'representing-perspectives'];
/**
 * Validation for a space's `format`. Shared by the `create` and `update` inputs
 * so the accepted set can't drift between them.
 */
exports.spaceFormatSchema = z.enum(exports.SPACE_FORMATS);
/**
 * Bounds on a space name's length.
 */
exports.SPACE_NAME_MIN_LENGTH = 1;
exports.SPACE_NAME_MAX_LENGTH = 85;
/**
 * Validation for a space's `name`. Shared by the `create` and `update` inputs
 * so the constraint can't drift between them.
 */
exports.spaceNameSchema = z.string().min(exports.SPACE_NAME_MIN_LENGTH).max(exports.SPACE_NAME_MAX_LENGTH);
// Output-only. A denormalized subset of `commentSchema` — just enough to
// render a byline and a line of text — so a teaser embed never has to fetch a
// full comment (with its `properties` bag, pin state, etc.) just to preview
// one.
exports.commentTeaserPreviewSchema = z.object({
    text: multi_language_1.multiLanguageStringSchema.describe('The comment body.'),
    originalLanguage: z
        .enum(locale_1.ALL_ISO_LOCALES)
        .optional()
        .describe('The language the comment was written in, when known — independent of whether `text` was translated.'),
    createdAt: schemas_1.isoDateTime.describe('When the comment was created.'),
    authorKey: z.string().describe("The comment author's persona key."),
    authorName: z.string().optional().describe("The author's display name, omitted if they have none."),
    authorPhoto: z.string().optional().describe("The author's photo URL, omitted if they have not set one."),
});
/**
 * Output-only. A space's comment-engagement summary: its counts, the time of
 * its newest comment, and the one comment a card previews.
 *
 * This is the `preview` property the `question-on-question` derived view keeps
 * fresh on every space, so a list of spaces can carry one per row without
 * ranking any space's comments. The featured comment `spaces.teaser` honours is
 * not reflected here — the derived view picks the top pinned comment, else the
 * newest — so a surface that must show the featured one reads `spaces.teaser`
 * for that space instead.
 */
exports.spacePreviewSchema = z.object({
    commentCount: z.number().describe('Total top-level comments in the space.'),
    time: z.number().describe("Timestamp of the space's most recent comment."),
    commentPreview: exports.commentTeaserPreviewSchema.nullish().describe('The top (pinned, else newest) comment, if any.'),
    participantCount: z.number().describe('People the space has recorded as participants, not only the ones who commented.'),
});
/**
 * Largest page `spaces.list` will embed a preview into. Each embedded row costs
 * its own instance-property read, and the endpoint is public with a limit that
 * reaches six figures, so the embed is bounded well below it.
 */
exports.PREVIEW_EMBED_MAX_LIMIT = 100;
/**
 * Wire-level shape returned by `spaces.*` procedures.
 *
 * `createdBy` is the resolved profile of the creator, key included via
 * `createdBy.profileKey` — resolved via `getPersonaAsync`, which never fails
 * to produce a profile: a creator with no saved preview yet still resolves
 * via the login-provider account, and one who later deletes their account
 * resolves to a placeholder (`deleted: true`). So there is no case where the
 * creator's identity is known but unrepresentable, and no separate key field
 * is needed.
 *
 * `moderationMode` is the space's moderation mode as a value, not as flags,
 * and the only field it is read or written through. Per-instance storage
 * encodes the mode as one feature key per mode, but those keys never appear
 * in `features` in either direction. A read reports `null` for a space with
 * no mode stored; no write can produce one.
 * `reactionSet` is likewise the space's reaction set as a value. Its keys do
 * still appear in `features`, but the server owns the translation and
 * `features` is not the field to read or write it through. `upvote` follows
 * from the space's format and has no key of its own.
 *
 * `name` is a `MultiLanguageString`: a plain string when there is no
 * translation to offer, or an `{ originalText, translations }` pair carrying
 * the original alongside a locale-keyed map — the locale the read named, or
 * every locale for a `*` read — so a multi-language silo (SRG serves every
 * business unit from one silo) can render a space list in the viewer's own
 * language. The underlying instance globals also translate the slider
 * labels, but those don't belong on this payload.
 */
// Output-only (never part of any `.input(...)`) — see the length-limits note
// in docs/architecture/orpc.md for why only inputs are bounded.
exports.spaceSchema = z
    .object({
    spaceKey: z.string().describe("The space's unique key within the silo."),
    id: z.string().optional().describe('Legacy numeric-style id, when one exists.'),
    name: multi_language_1.multiLanguageStringSchema.describe("The space's display name."),
    format: z.string().nullable().describe('The conversation format for the space.'),
    features: z
        .record(z.string(), z.boolean())
        .nullable()
        .describe('Per-space feature toggles keyed by feature key, or null when none are set.'),
    moderationMode: moderation_modes_1.moderationModeSchema.describe("Which of the four moderation modes the space runs. A space that stores no mode runs in the silo's default."),
    reactionSet: reaction_sets_1.reactionSetSchema.describe('How readers react to comments in the space: one of the emoji sets, or `upvote` for an audience-input space.'),
    status: spaceStatusSchema.describe('Whether the space is active, closed, or in draft.'),
    createdAt: schemas_1.isoDateTime.describe('When the space was created.'),
    createdBy: types_1.userProfileSchema.describe("The creator's resolved public profile."),
    commentCount: z.number().describe('Number of comments in the space.'),
    isHeated: z.boolean().optional().describe('Whether the space is currently flagged as heated.'),
    lastActivity: schemas_1.isoDateTime.optional().describe('When the space last saw activity.'),
    preview: exports.spacePreviewSchema
        .nullish()
        .describe("The space's comment-engagement preview, when the listing endpoint embeds one. Null when the space has no comments " +
        'yet, absent on reads that do not embed it.'),
})
    .describe('A conversation space within a silo, with its format, feature toggles, creator, and activity summary.');
const create = base_1.baseProcedure
    .route({
    method: 'POST',
    path: '/silo/{siloKey}/spaces',
    tags: ['Spaces'],
    summary: 'Create a space',
    description: 'Create a conversation space for an organization to steward a discussion with its audience, and return it. It lands in ' +
        '`draft` status with the caller as its creator; publish it by setting `status` to `active` through `spaces.update`. The ' +
        "space's key is derived from its name, so two spaces cannot share one: a name already taken is refused with " +
        'DUPLICATE_SPACE, and a name with no alphanumeric character in it with INVALID_NAME. A format the silo has switched off ' +
        'is refused with FORMAT_NOT_ENABLED. `moderationMode` sets how the space moderates posts; omit it and the space gets the ' +
        "silo's default mode. A mode the silo has switched off is refused with MODERATION_MODE_NOT_ENABLED. `reactionSet` " +
        'sets which emoji reactions the space offers, and is the default set when omitted; an audience-input space offers an ' +
        'upvote instead, and keeps the set for if it changes format.',
})
    .meta({ access: 'admin', capability: roles_capabilities_1.EDITORIALDASH_MANAGE_CAPABILITY })
    .input(z.object({
    ...api_schemas_1.siloParams,
    name: exports.spaceNameSchema,
    features: (0, api_schemas_1.boundedRecord)(z.boolean()).optional(),
    format: exports.spaceFormatSchema,
    moderationMode: moderation_modes_1.moderationModeSchema.optional(),
    reactionSet: reaction_sets_1.emojiReactionSetSchema.optional(),
}))
    .output(exports.spaceSchema)
    .errors({
    INVALID_NAME: { status: 400, data: z.object({ name: z.string() }) },
    DUPLICATE_SPACE: { status: 409, data: z.object({ spaceKey: z.string() }) },
    FORMAT_NOT_ENABLED: { status: 403, data: z.object({ format: z.string() }) },
    MODERATION_MODE_NOT_ENABLED: { status: 403, data: z.object({ moderationMode: z.string() }) },
});
function errorInvalidName(name) {
    return new client_1.ORPCError('INVALID_NAME', {
        status: 400,
        data: { name },
        message: 'Space name must contain at least one alphanumeric character',
    });
}
function errorDuplicateSpace(spaceKey) {
    return new client_1.ORPCError('DUPLICATE_SPACE', {
        status: 409,
        data: { spaceKey },
        message: 'Space already exists: ' + spaceKey,
    });
}
function errorFormatNotEnabled(format) {
    return new client_1.ORPCError('FORMAT_NOT_ENABLED', {
        status: 403,
        data: { format },
        message: 'Format is not enabled for this silo: ' + format,
    });
}
function errorModerationModeNotEnabled(moderationMode) {
    return new client_1.ORPCError('MODERATION_MODE_NOT_ENABLED', {
        status: 403,
        data: { moderationMode },
        message: 'Moderation mode is not enabled for this silo: ' + moderationMode,
    });
}
const list = base_1.baseProcedure
    .route({
    method: 'GET',
    path: '/silo/{siloKey}/spaces',
    tags: ['Spaces'],
    summary: 'List spaces',
    description: 'List the conversation spaces in the silo, newest first, one page at a time: `offset` spaces are skipped and up to `limit` ' +
        'returned (100 by default), with `total` counting every space that matches. `query.name` keeps ' +
        'the spaces whose name contains that text, matched without regard to case; `query.status` keeps the ones in any of the ' +
        'statuses it lists, so asking for `["active", "closed"]` returns every published space in one query, with `total` ' +
        'counting the same set. `query.isHeated` keeps the spaces currently flagged as heated, and `query.needsReview` the ones ' +
        'with posts awaiting a moderation decision, which takes moderator access and is refused with FORBIDDEN without it. ' +
        'Draft spaces are visible to an admin only, so the same call returns fewer spaces to everyone else. ' +
        "`includePreview` embeds each row's engagement preview, at the cost of a read per space, so it is limited to pages of " +
        `${exports.PREVIEW_EMBED_MAX_LIMIT} and left off by default. ` +
        'An input this procedure does not take, such as the `cursor` it took before it paged by `offset`, is refused with ' +
        'BAD_REQUEST rather than ignored.',
})
    .meta({ access: 'public' })
    .input(z
    .object({
    ...api_schemas_1.siloReadParams,
    ...api_schemas_1.paginationParams,
    includePreview: z.boolean().optional(),
    query: z
        .object({
        name: z.string().max(exports.SPACE_NAME_MAX_LENGTH).optional(),
        status: z.array(spaceStatusSchema).min(1).max(3).optional(),
        isHeated: z.literal(true).optional(),
        needsReview: z.literal(true).optional(),
    })
        .strict()
        .optional(),
})
    .strict()
    .refine((value) => !value.includePreview || value.limit <= exports.PREVIEW_EMBED_MAX_LIMIT, {
    path: ['includePreview'],
    error: `includePreview requires a limit of ${exports.PREVIEW_EMBED_MAX_LIMIT} or fewer`,
}))
    .output(z.object({
    items: z.array(exports.spaceSchema),
    total: z.number(),
}));
const get = base_1.baseProcedure
    .route({
    method: 'GET',
    path: '/silo/{siloKey}/spaces/{spaceKey}',
    tags: ['Spaces'],
    summary: 'Get a space',
    description: "Get one conversation space: its name, prosocial format, enabled features, moderation mode, reactions, and status, plus its creator's " +
        'resolved ' +
        'profile, its comment count, and when it last saw activity. A draft space is visible to an admin only: to anyone else it ' +
        'reads as NOT_FOUND, the same as a key that was never used.',
})
    .meta({ access: 'public' })
    .input(z.object({
    ...api_schemas_1.spaceReadParams,
}))
    .output(exports.spaceSchema);
const update = base_1.baseProcedure
    .route({
    method: 'PATCH',
    path: '/silo/{siloKey}/spaces/{spaceKey}',
    tags: ['Spaces'],
    summary: 'Update a space',
    description: 'Update a conversation space, changing the fields you send and leaving the others as they are. `features` merges into the ' +
        'current map, so you can flip one flag without restating the rest; changing it also takes the ' +
        '`features/toggle-stable` capability, and is refused with FORBIDDEN without it. `moderationMode` switches the whole mode in one field ' +
        'and is the only way to change it; a mode the silo has switched off is refused with MODERATION_MODE_NOT_ENABLED. ' +
        '`reactionSet` picks the emoji reactions the space offers; an audience-input ' +
        'space reports `upvote` and keeps the set for if it changes format. Send it rather than flipping flags through ' +
        '`features`. ' +
        '`status` moves the space between `draft` (not yet ' +
        'published), `active` (open for comments), and `closed` (published, but no new comments). Renaming a space also rewrites ' +
        'its title in every story that embeds it. A format the silo has switched off is refused with FORMAT_NOT_ENABLED, and an ' +
        'unknown space with NOT_FOUND.',
})
    .meta({ access: 'admin', capability: roles_capabilities_1.EDITORIALDASH_MANAGE_CAPABILITY })
    .input(z.object({
    ...api_schemas_1.spaceParams,
    name: exports.spaceNameSchema.optional(),
    format: exports.spaceFormatSchema.optional(),
    features: (0, api_schemas_1.boundedRecord)(z.boolean()).optional(),
    moderationMode: moderation_modes_1.moderationModeSchema.optional(),
    reactionSet: reaction_sets_1.emojiReactionSetSchema.optional(),
    status: spaceStatusSchema.optional(),
}))
    .output(exports.spaceSchema)
    .errors({
    FORMAT_NOT_ENABLED: { status: 403, data: z.object({ format: z.string() }) },
    MODERATION_MODE_NOT_ENABLED: { status: 403, data: z.object({ moderationMode: z.string() }) },
});
// Output-only. Everything a teaser embed renders, in one payload. This is the
// v2 successor to the legacy `/questions/getMetadata`: `name` maps to its
// `title`, `topLevelCount` to `preview.commentCount`, `participantCount` to
// `preview.participantCount`, and `commentPreview` to `preview.commentPreview`.
// Space timestamps getMetadata also returned (created / last-activity) are
// not duplicated here — they're served by `spaces.get`.
//
// `features` is the instance's own map rather than the denormalised copy on the
// silo-level question row, the same substitution `spaces.get` makes, so a space
// toggled through the dev feature menu reads correctly here.
exports.spaceTeaserSchema = z.object({
    name: multi_language_1.multiLanguageStringSchema.describe("The space's name."),
    topLevelCount: z.number().describe('Number of visible top-level (non-reply) comments.'),
    participantCount: z.number().describe('Number of participants that have interacted with the space.'),
    commentPreview: exports.commentTeaserPreviewSchema
        .nullable()
        .describe("The comment to preview: the space's featured comment if one is set, else the top-level comment ranked first by `sort`."),
    features: z
        .record(z.string(), z.boolean())
        .describe('Which features are turned on for this space, read from the instance itself, and empty when none are. Included so an ' +
        'embed can decide from this one call whether a per-feature read is worth making at all.'),
});
// `sort` picks which top-level comment leads when no comment is featured, so
// an embed can preview what a reader will find at the top of the space rather
// than always the most recent. It takes the same ranker keys as
// `comments.list` and defaults to `most-recent`.
const teaser = base_1.baseProcedure
    .route({
    method: 'GET',
    path: '/silo/{siloKey}/spaces/{spaceKey}/teaser',
    tags: ['Spaces'],
    summary: 'Get a space preview for a teaser embed',
    description: 'Get the preview a teaser embed renders where a space is promoted outside the conversation itself. Returns everything ' +
        "that embed needs in one call: the space's name (with translations), its top-level comment count, its participant count, " +
        "a single comment to preview, which is the space's featured comment if one is set and otherwise the top comment under " +
        '`sort`, and the features turned on for the space. Saves the embed from fetching the space and the full ranked comment ' +
        'tree. A draft space is visible to an admin only: to anyone else it reads as NOT_FOUND, the same as a key that was never ' +
        'used.',
})
    .meta({ access: 'public' })
    .input(z.object({ ...api_schemas_1.spaceReadParams, sort: api_schemas_1.shortString.optional() }))
    .output(exports.spaceTeaserSchema);
/**
 * Wire-level shape of one story linked into a space, projected from the
 * stored `backlink_article` row. The row also carries a denormalised copy of
 * the story's details that the wire shape deliberately doesn't serve (see the
 * handler in `server/orpc/routers/spaces.ts`).
 *
 * Trimmed to the four fields every consumer renders. `type` distinguishes the
 * "Read article" and "View video" link labels in the linked-stories modal.
 */
// Output-only (never part of any `.input(...)`) — see the length-limits note
// in docs/architecture/orpc.md for why only inputs are bounded.
exports.linkedStorySchema = z.object({
    url: z.string().describe("The linked story's URL."),
    title: z.string().describe("The linked story's title."),
    imageUrl: z.string().nullable().describe('Lead image URL, or null when none was found.'),
    type: z.enum(['article', 'video']).describe('Whether the story is a written article or a video.'),
});
const linkedStories = base_1.baseProcedure
    .route({
    method: 'GET',
    path: '/silo/{siloKey}/spaces/{spaceKey}/linked-stories',
    tags: ['Spaces'],
    summary: "List a space's linked stories",
    description: 'The external stories that link into this space: the pages readers clicked through from to reach it, plus any story an ' +
        "editor attached by hand. Public, because the same list is already published unauthenticated as the space page's " +
        'schema.org structured data.',
})
    .meta({ access: 'public' })
    .input(z.object(api_schemas_1.spaceReadParams))
    .output(z.object({ items: z.array(exports.linkedStorySchema) }));
const featureComment = base_1.baseProcedure
    .route({
    method: 'PUT',
    path: '/silo/{siloKey}/spaces/{spaceKey}/featured-comment',
    tags: ['Spaces'],
    summary: 'Feature a comment in the space',
    description: 'Feature a comment so a teaser embed promoting this space previews it, and return that comment. Replaces whatever was ' +
        'featured before, since a space has at most one featured comment.',
})
    .meta({ access: 'admin', capability: roles_capabilities_1.STEWARD_COMMENTS_CAPABILITY })
    .input(z.object({ ...api_schemas_1.spaceParams, commentKey: api_schemas_1.shortString }))
    .output(comments_1.commentSchema)
    .errors({});
const unfeatureComment = base_1.baseProcedure
    .route({
    method: 'DELETE',
    path: '/silo/{siloKey}/spaces/{spaceKey}/featured-comment',
    tags: ['Spaces'],
    summary: "Clear the space's featured comment",
    description: 'Clear the featured comment a teaser embed previews for this space, so the embed falls back to the most recent top-level ' +
        'comment, and return that comment. A no-op if `commentKey` is no longer the featured one.',
})
    .meta({ access: 'admin', capability: roles_capabilities_1.STEWARD_COMMENTS_CAPABILITY })
    .input(z.object({ ...api_schemas_1.spaceParams, commentKey: api_schemas_1.shortString }))
    .output(comments_1.commentSchema)
    .errors({});
exports.spacesContract = { create, list, get, update, teaser, linkedStories, featureComment, unfeatureComment };
//# sourceMappingURL=spaces.js.map